import React from "react";
import styled from "styled-components";
import { theme } from "../theme";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import { BigText } from "./shared/BigText";
import { Chip } from "./shared/Chip";
import { CTAButton } from "./shared/Button";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { scrollToSection } from "./shared/utils";
import { CTAText } from "./shared/CTAText";

const Bg = styled.div`
  padding: 70px 0;
  width: 100vw;
  background-color: ${theme.colors.white};
  background-image: url("img/logo-bg.png");
  background-position: top left;
  background-repeat: no-repeat;
  background-size: 30%;
`;

const Wrapper = styled.div`
  margin: auto;
  max-width: 1000px;
  padding: 0 5%;
`;

const bigTextStyles = {
  maxWidth: 800,
  margin: "auto",
  marginBottom: 30,
};

const GridStyled = styled.div`
  display: grid;
  max-width: 900px;
  margin: auto;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-top: 30px;

  @media (min-width: 915px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const GridColumn = styled.div`
  max-width: 400px;
  margin: auto;
`;

const HighlightText = styled.span`
  color: ${theme.colors.orange};
  font-weight: 600;
`;

const ChipsContainer = styled.div`
  display: flex;
  margin: 20px 0 0 10px;
  flex-wrap: wrap;
  gap: 25px;
  font-size: 14px;

  @media (min-width: 420px) {
    font-size: 16px;
  }
`;

const WrapperInterviews = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
`;

const Interviews = styled.div`
  padding: 8px 15px;
  border-radius: 15px;
  background: #ffebe2;
  font-weight: 500;
  text-align: center;
`;

const CheckItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  & svg {
    color: ${theme.colors.blue};
  }
`;

const ChecksRow = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  max-width: 500px;

  @media (min-width: 600px) {
    flex-direction: row;
    justify-content: space-between;
    max-width: auto;
  }
`;

const CheckItem = ({ children }) => {
  return (
    <CheckItemContainer>
      <CheckRoundedIcon />
      <span>{children}</span>
    </CheckItemContainer>
  );
};

export const Companies = () => {
  return (
    <Bg>
      <Wrapper>
        <Subtitle>
          En un mundo donde las empresas compiten por el talento, tú tienes el
          poder de elegir
        </Subtitle>
        <Title>
          ¿Y si en vez de buscar trabajo fuesen las empresas las que te buscan a
          ti?
        </Title>
        <BigText styles={bigTextStyles}>
          Pasarás de esperar a que te seleccionen a ser tú el que elija con que
          empresa quieres trabajar.
        </BigText>
        <p>
          La escasez de talento en este sector hace que las empresas ofrezcan{" "}
          <b>salarios competitivos</b>, beneficios increíbles y{" "}
          <b>oportunidades de crecimiento constante</b>. En Beyond serás parte
          activa de un <b>proyecto profesional real</b> y desarrollarás un
          perfil profesional que te hará interesante para los reclutadores.
        </p>
        <CTAText>
          Este es tu momento para aprovechar la alta demanda y convertirte en{" "}
          <b>el profesional que todos quieren tener</b>
        </CTAText>
        <GridStyled>
          <GridColumn>
            <p>
              Tecnologías de{" "}
              <HighlightText>Desarrollo Web Frontend</HighlightText>:
            </p>
            <ChipsContainer>
              <Chip icon="img/html.svg">HTML</Chip>
              <Chip icon="img/css.svg">CSS</Chip>
              <Chip icon="img/javascript.svg">Javascript</Chip>
              <Chip icon="img/fw-css.svg" bigIcon>
                Bootstrap / Tailwind
              </Chip>
              <Chip icon="img/sass.svg">Preprocesadores de CSS (Sass)</Chip>
              <Chip icon="img/react.svg" bigIcon>
                React (con Redux)
              </Chip>
            </ChipsContainer>
          </GridColumn>
          <GridColumn>
            <p>
              <HighlightText>Habilidades</HighlightText> transversales:
            </p>
            <ChipsContainer>
              <Chip icon="img/scrum.svg">Metodologías ágiles (Scrum)</Chip>
              <Chip icon="img/git.svg" bigIcon>
                Control de versiones (Git, GitHub)
              </Chip>
              <Chip icon="img/firebase.svg">
                Bases de datos, API Rest (Firebase)
              </Chip>
              <Chip icon="img/figma.svg">UX UI (Figma)</Chip>
            </ChipsContainer>
          </GridColumn>
        </GridStyled>
        <WrapperInterviews>
          <Interviews>
            🏆 &nbsp; ¡Y formación específica para superar entrevistas técnicas!
          </Interviews>
          <ChecksRow>
            <CheckItem>6 meses</CheckItem>
            <CheckItem>Part time</CheckItem>
            <CheckItem>Clases en vivo</CheckItem>
            <CheckItem>Online</CheckItem>
          </ChecksRow>
          <CTAButton handleClick={() => scrollToSection("contact")}>
            Me quiero apuntar 👩‍💻
          </CTAButton>
        </WrapperInterviews>
      </Wrapper>
      <span id="subjects"></span>
    </Bg>
  );
};
